'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import PresentationRecord from '../records/PresentationRecord';
import Loadable from 'UIComponents/decorators/Loadable';
import PublicView from '../components/view/PublicView';
import { trackInteraction } from '../tracking/tracker';
import { DOCUMENT_VIEW } from '../tracking/actions';
import hubspotGTMContainer from '../utils/hubspotGTMContainer';
import isMobile from 'isMobile';
const LoadableViewNotAvailable = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  '../components/view/ViewNotAvailable')
});
const LoadableViewNotFound = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  '../components/view/ViewNotFound')
});
const LoadableViewError = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  '../components/view/ViewError')
});
const LoadableNoPermissionError = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  '../components/view/NoPermissionError')
});
export default class ViewContainer extends Component {
  componentDidMount() {
    hubspotGTMContainer();

    if (this.props.presentation) {
      trackInteraction(DOCUMENT_VIEW);
      this.props.fetchMeetingLink();
    }

    if (!isMobile.any) {
      // Load the chat widget as long as we aren't on mobile. Automatic loading
      // is disabled in a script tag in view.html.jade
      window.hsConversationsOnReady = [() => {
        window.HubSpotConversations.widget.load();
      }];
    }
  }

  render() {
    const {
      presentation,
      presentationNotFound,
      presentationNotAvailableEndDate,
      meetingLink,
      identifyViewer,
      finishActivity,
      fetchDownloadLink,
      noPermission
    } = this.props;

    if (presentationNotAvailableEndDate) {
      return /*#__PURE__*/_jsx(LoadableViewNotAvailable, {
        endDate: presentationNotAvailableEndDate
      });
    }

    if (presentation === undefined) {
      if (presentationNotFound) {
        return /*#__PURE__*/_jsx(LoadableViewNotFound, {});
      }

      if (noPermission) {
        return /*#__PURE__*/_jsx(LoadableNoPermissionError, {});
      }

      return /*#__PURE__*/_jsx(LoadableViewError, {});
    }

    return /*#__PURE__*/_jsx(PublicView, {
      presentation: presentation,
      meetingLink: meetingLink,
      onIdentifyViewer: identifyViewer,
      onFinishActivity: finishActivity,
      fetchDownloadLink: fetchDownloadLink
    });
  }

}
ViewContainer.propTypes = {
  presentation: PropTypes.instanceOf(PresentationRecord),
  presentationNotFound: PropTypes.bool,
  presentationNotAvailableEndDate: PropTypes.number,
  noPermission: PropTypes.bool,
  meetingLink: PropTypes.string,
  identifyViewer: PropTypes.func,
  finishActivity: PropTypes.func,
  fetchDownloadLink: PropTypes.func.isRequired,
  fetchMeetingLink: PropTypes.func.isRequired
};